import type { MeetingSeries } from '@entities/meetings';
import type { PtoProject } from '@shared/api';

/** Аудио/видео-форматы записи совещания (вход ASR в doc-processor). */
export const RECORDING_ACCEPT = '.mp3,.wav,.m4a,.ogg,.opus,.mp4,.webm,.mkv';

/** Без `.rtf`: doc-processor его не детектит и отвечает 400 уже после заливки
 *  (`_detect_format` в `doc-processor/app/main.py` — ветки под rtf нет). */
export const PROTOCOL_DOC_ACCEPT = '.docx,.doc,.txt,.pdf';

export interface UploadContextProps {
  seriesList: MeetingSeries[];
  projects: PtoProject[];
}
